import { Controller } from "stimulus";
import i18n from "../../packs/i18n"
import i18next from "i18next";

export default class extends Controller {
  static targets = ["discount", "testSelector", "startDate", "endDate", "fullPrice", "testPrice"]

  connect(){
    $('.selectpicker').selectpicker();

    $(this.startDateTarget).datepicker()
    $(this.endDateTarget).datepicker()

    i18n.then(()=> {
      this.initValidation()
    })
  }

  initValidation(){
    let testPrice = this.testPriceTarget
    let testSelectorId = this.testSelectorTarget.id;
    let discountId = this.discountTarget.id;

    $(this.element).validate({
      ignore: [],
      errorPlacement: function(error, element) {
        switch (element.attr("id")) {
          case testSelectorId:
            element.parent().parent().append(error);
            break;
          case discountId:
            element.parent().parent().append(error);
            break;
          default:
            element.parent().append(error);
            break;
        }
      }
    });


    $(this.testSelectorTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
    })

    $(this.startDateTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });

      $(this).rules('add', {
        dateFormat: true,
        messages: {
          dateFormat: i18next.t('valid_data_format')
        }
      });
    });

    $(this.endDateTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
      $(this).rules('add', {
        dateFormat: true,
        messages: {
          dateFormat: i18next.t('valid_data_format')
        }
      });
    });

    $(this.discountTarget).each(function () {
      $(this).rules('add', {
        required: true,
        max: function(){
          return +parseFloat(testPrice.value).toFixed(2)
        },
        messages: {
          required: i18next.t('required_field'),
          max:  i18next.t('max_number_with_sign', { sign: '$', number: "{0}" }),
        }
      });
    });
  }
}